import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initCounterAnimations() {
    const statsElements = document.querySelectorAll('[data-stat-number]');
    
    if (statsElements.length === 0) return;

    statsElements.forEach((element) => {
        const finalValue = parseFloat(element.dataset.statNumber);
        const duration = parseFloat(element.dataset.duration) || 2;
        const counter = { value: 0 };
        
        ScrollTrigger.create({
            trigger: element,
            start: "top 80%",
            end: "bottom 20%",
            onEnter: () => {
                gsap.to(counter, {
                    value: finalValue,
                    duration: duration,
                    ease: "power2.out",
                    onUpdate: () => {
                        const displayValue = Number.isInteger(finalValue) ? 
                            Math.floor(counter.value) : 
                            counter.value.toFixed(1);
                        element.querySelector('.stat-value').textContent = displayValue;
                    },
                    onComplete: () => {
                        element.querySelector('.stat-value').textContent = finalValue;
                    }
                });
            },
            onLeave: () => {
                gsap.to(counter, {
                    value: 0,
                    duration: 0.8,
                    ease: "power2.out",
                    onUpdate: () => {
                        const displayValue = Number.isInteger(finalValue) ? 
                            Math.floor(counter.value) : 
                            counter.value.toFixed(1);
                        element.querySelector('.stat-value').textContent = displayValue;
                    },
                    onComplete: () => {
                        element.querySelector('.stat-value').textContent = '0';
                    }
                });
            },
            onEnterBack: () => {
                gsap.to(counter, {
                    value: finalValue,
                    duration: duration,
                    ease: "power2.out",
                    onUpdate: () => {
                        const displayValue = Number.isInteger(finalValue) ? 
                            Math.floor(counter.value) : 
                            counter.value.toFixed(1);
                        element.querySelector('.stat-value').textContent = displayValue;
                    },
                    onComplete: () => {
                        element.querySelector('.stat-value').textContent = finalValue;
                    }
                });
            },
            onLeaveBack: () => {
                gsap.to(counter, {
                    value: 0,
                    duration: 0.8,
                    ease: "power2.out",
                    onUpdate: () => {
                        const displayValue = Number.isInteger(finalValue) ? 
                            Math.floor(counter.value) : 
                            counter.value.toFixed(1);
                        element.querySelector('.stat-value').textContent = displayValue;
                    },
                    onComplete: () => {
                        element.querySelector('.stat-value').textContent = '0';
                    }
                });
            }
        });
    });
}
